import React, { PureComponent } from 'react';
import _ from 'lodash';

import { Icon } from '@breezeway/brzw-components';
import getHistory from 'globalHistory';
import PriorityPill from '../../priority_pill';
import StatusPill from '../../status_pill';
import { CLASS_NAME, LINK_TYPES } from './constants';

const changeUrl = path => () => getHistory().push(path);

const onClickLink = link => {
  const type = _.get(link, 'type', null);
  const id = _.get(link, 'id', null);

  switch (type) {
    case LINK_TYPES.TEMPLATE:
      return changeUrl(`/settings/task/${id}`);
    case LINK_TYPES.COMPANY_PERSON:
      return changeUrl(`/company/people/${id}`);
    case LINK_TYPES.TASK:
      return changeUrl(`/task/${id}`);
    default:
      return () => {};
  }
};

class HistoryRowSections extends PureComponent {
  static renderTextObject(textObject) {
    const type = _.get(textObject, 'type', null);
    const text = _.get(textObject, 'text', '');

    if (!type) {
      return <span className={`${CLASS_NAME}__text ${CLASS_NAME}__text--strong`}>{text}</span>;
    }

    return (
      <span
        onClick={onClickLink(textObject, getHistory())}
        className={`${CLASS_NAME}__text ${CLASS_NAME}__text--link`}
        role="presentation"
      >
        {text}
      </span>
    );
  }

  static renderChangeObject(changeObject) {
    const oldValue = _.get(changeObject, 'old', null);
    const newValue = _.get(changeObject, 'new', null);

    return (
      <>
        {oldValue && <span className={`${CLASS_NAME}__text`}>{` from ${oldValue}`}</span>}
        {newValue && (
          <>
            <span className={`${CLASS_NAME}__text`}> to</span>
            <span
              className={`${CLASS_NAME}__text ${CLASS_NAME}__text--strong`}
            >{` ${newValue}`}</span>
          </>
        )}
      </>
    );
  }

  static renderScheduleUpdates(scheduleUpdates) {
    return (
      <div className={`${CLASS_NAME}__custom-section`}>
        {_.map(scheduleUpdates, (scheduleObject, index) => {
          const oldValue = _.get(scheduleObject, 'old', null);
          const newValue = _.get(scheduleObject, 'new', null);
          const text = _.get(scheduleObject, 'text', null);

          return (
            <div className={`${CLASS_NAME}__schedule-update`} key={index}>
              {text && <span className={`${CLASS_NAME}__schedule-update-title`}>{text}:</span>}
              {oldValue && (
                <span className={`${CLASS_NAME}__schedule-update-from`}>{oldValue}</span>
              )}
              {newValue && oldValue && (
                <div className={`${CLASS_NAME}__schedule-update-icon-wrapper`}>
                  <Icon className={`${CLASS_NAME}__schedule-update-icon`} iconName="high" />
                </div>
              )}
              {newValue && <span className={`${CLASS_NAME}__schedule-update-to`}>{newValue}</span>}
            </div>
          );
        })}
      </div>
    );
  }

  static renderStatusObject(statusObject) {
    const oldStatus = _.get(statusObject, 'old', null);
    const newStatus = _.get(statusObject, 'new', null);
    const newHasStatusTimer = _.has(newStatus, 'timer_active');
    const oldHasStatusTimer = _.get(oldStatus, 'timer_active');
    const oldStatusTimer = _.get(oldStatus, 'timer_active');
    const newStatusTimer = _.get(newStatus, 'timer_active');

    return (
      <div className={`${CLASS_NAME}__custom-section`}>
        {oldStatus && (
          <>
            <span className={`${CLASS_NAME}__custom-section-text`}>status changed from</span>
            <StatusPill
              active={oldStatusTimer}
              className={`${CLASS_NAME}__status-pill`}
              code={oldStatus.code}
              name={oldStatus.name}
              withIcon={oldHasStatusTimer}
            />
          </>
        )}
        {newStatus && (
          <>
            <span className={`${CLASS_NAME}__custom-section-text`}>
              {oldStatus ? 'to' : 'status'}
            </span>
            <StatusPill
              active={newStatusTimer}
              className={`${CLASS_NAME}__status-pill`}
              code={newStatus.code}
              name={newStatus.name}
              withIcon={newHasStatusTimer}
            />
          </>
        )}
      </div>
    );
  }

  static renderPriorityObject(priorityObject) {
    const oldPriority = _.get(priorityObject, 'old', null);
    const newPriority = _.get(priorityObject, 'new', null);

    return (
      <div className={`${CLASS_NAME}__custom-section`}>
        {oldPriority && (
          <PriorityPill
            className={`${CLASS_NAME}__priority-pill ${CLASS_NAME}__priority-pill--old`}
            code={oldPriority.code}
            name={oldPriority.name}
          />
        )}
        {newPriority && (
          <>
            {oldPriority && <span className={`${CLASS_NAME}__custom-section-text`}>to</span>}
            <PriorityPill
              className={`${CLASS_NAME}__priority-pill`}
              code={newPriority.code}
              name={newPriority.name}
            />
          </>
        )}
      </div>
    );
  }
}

export default HistoryRowSections;
